import { provideZoneChangeDetection } from '@angular/core';
import './polyfills';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/';
import { AppConfig } from './app/app.config';
import { environment } from './environments/environment';
import { LocaleHelper } from './app/l10n-config';

/** Register our supported locales. See: LocaleHelper */
LocaleHelper.registerNgLocales();

// Setup app config
AppConfig.setSourceConfiguration(environment);

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .then()
  .catch(error => console.error(error));
